module.exports = __webpack_public_path__ + "93c4dc9c3065f703420191e4cc4991a2.pdf";